export default function ImageBanner() {
  return (
    <section className="relative w-full overflow-hidden" style={{ height: '520px' }}>
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=serene%20warm%20family%20moment%20at%20golden%20hour%2C%20soft%20sunlight%20through%20large%20windows%2C%20people%20embracing%20with%20love%20and%20care%2C%20cozy%20home%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20blurred%20bokeh%20background%2C%20no%20hospital%20no%20funeral%2C%20artistic%20lifestyle%20photography%2C%20cinematic%20depth%20of%20field%2C%20peaceful%20and%20hopeful%20mood%2C%20rich%20warm%20palette%20with%20soft%20shadows&width=1440&height=520&seq=cfbanner2026&orientation=landscape')`,
        }}
      />
      {/* Overlay */}
      <div
        className="absolute inset-0"
        style={{ background: 'linear-gradient(120deg, rgba(13,5,32,0.88) 0%, rgba(13,5,32,0.65) 50%, rgba(60,52,137,0.45) 100%)' }}
      />

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6 pt-20">
        <h1 className="font-title text-4xl sm:text-5xl md:text-6xl text-white leading-[1.06] mb-5 max-w-3xl">
          ¿Qué es{' '}
          <span style={{ color: '#AFA9EC' }}>Coverly?</span>
        </h1>

        <p className="text-white/70 text-base md:text-xl leading-relaxed max-w-2xl font-light mb-4">
          Coverly es una membresía de previsión funeraria que ayuda a tu familia a tener orden y te permite elegir cómo resolver todo cuando llegue el momento.
        </p>

        <p className="text-white/50 text-sm md:text-base font-light">
          Una solución simple, humana y accesible.
        </p>
      </div>
    </section>
  );
}
